export default "__VITE_ASSET__B5pAza0i__"